import React from "react";

export default function MySQL_ROUND() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_ROUND</h1>
      <p>This is the MySQL_ROUND component generated from the SQL JSON.</p>
    </div>
  );
}
